exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: fixed;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  bottom: 16px;\n  right: 16px;\n  padding: 2px 4px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background: #EEE;\n  min-width: 300px; }\n\nbutton {\n  margin: 2px 0;\n  background: #c8c8c8;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  padding: 2px 4px;\n  font-family: inherit;\n  font-weight: 700; }\n\ndiv {\n  margin: 2px 0;\n  padding: 2px 4px; }\n\nh2 {\n  font-size: 115%;\n  margin: 4px 2px 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3); }\n\n:host.isDead {\n  border-color: #AA1111;\n  background: rgba(170, 17, 17, 0.65); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/HeinousTugboat/Projects/survivalism/src/app/debug-scorecard/debug-scorecard.component.scss
// module id = ../../../../../src/app/debug-scorecard/debug-scorecard.component.scss
// module chunks = main